<div class="p-mt-3 p-d-flex p-jc-end" *ngIf="editMode=== 'row'">
      <button pButton pRipple [label]="'GLOBAL.NUEVO' | translate" icon="pi pi-plus" class="p-button-success p-mr-2" (click)="new()"></button>
</div>
<p-table #dt [columns]="cols" [value]="values" [paginator]="paginator"
 [rows]="rows" class="p-m-5" [lazy]='lazy' [totalRecords]='totalRecords'
 [responsive]="responsive"
 [first]="paginaActual"
 [loading]="loading" dataKey="id" [editMode]="editMode"
 (onPage)="lazyLoading($event)"
 [globalFilterFields]="globalFilterFields">
 <ng-template pTemplate="caption">
 <!--<div class="p-d-flex p-ai-center p-jc-between">
      <h5 class="p-m-0">{{section}}</h5>
      <span class="p-input-icon-left">
          <i class="pi pi-search p-mr-2"></i>
          <input pInputText type="text" (input)="filter($event.target.value, 'contains')" [placeholder]="'GLOBAL.BUSCAR' |translate"/>
      </span>
  </div>-->
</ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
        <th *ngFor="let col of columns">
            {{col.header}}
        </th>
        <th>{{'GLOBAL.ACCIONES' | translate}}</th>
    </tr>
  </ng-template>
  <ng-template *ngIf="values.length > 0" pTemplate="body" let-rowData let-columns="columns" let-editing="editing" let-ri="rowIndex">
    <tr [pEditableRow]="rowData">
      <td *ngFor="let col of columns" [ngSwitch]="col.type">
        <p-cellEditor >
          <ng-template pTemplate="input">
            <input *ngSwitchCase="'string'" [disabled]="col.field === 'id' || col.EditDis" pInputText type="text" [(ngModel)]="rowData[col.field]"/>
            <p-dropdown *ngSwitchCase="'select'" styleClass="w-100"  [options]="col.data" optionLabel="nombre" [dataKey]="col.optionLabel" [(ngModel)]="rowData[col.field]" ></p-dropdown>
          </ng-template>
        <ng-template pTemplate="output">
          <p *ngSwitchCase="'string'" >{{rowData[col.field]}}</p>
          <p *ngSwitchCase="'link'"><a [href]="col.url + '/' + rowData[col.id]">{{rowData[col.field]}}</a></p>
          <p *ngSwitchCase="'select'" >{{rowData[col.field]}}</p>
          <!--<p-dropdown *ngSwitchCase="'select'" styleClass="w-100" [disabled]="true"  [options]="col.data" optionLabel="nombre" [dataKey]="col.optionLabel" [(ngModel)]="rowData[col.field]" ></p-dropdown>-->
        </ng-template>
        </p-cellEditor>

      </td>
      <td>
        <button *ngIf="!editing && editMode === 'row' && !editDeleteOnly"  pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"  class="p-button-rounded p-button-text p-mr-2" [pTooltip]="'GLOBAL.EDITAR' | translate" tooltipPosition="top" (click)="onRowEditInit(rowData)"></button>
        <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"  class="p-button-rounded p-button-text p-button-success p-mr-2" [pTooltip]="'GLOBAL.GUARDAR' | translate" tooltipPosition="top" (click)="onRowEditSave(rowData, ri)" ></button>
        <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"  class="p-button-rounded p-button-text p-button-danger" [pTooltip]="'GLOBAL.CANCELAR' | translate" tooltipPosition="top" (click)="onRowEditCancel(rowData, ri)"></button>
        <button *ngIf="editMode !== 'row' && !editDeleteOnly && !showOnly " pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" [pTooltip]="'GLOBAL.EDITAR' | translate" tooltipPosition="top" (click)="goToEdit(rowData.id)" ></button>
        <button *ngIf="cerrarSesion && !showOnly" class="p-mr-2" pButton pRipple type="button" icon="pi pi-sign-out" [pTooltip]="'GLOBAL.CERRAR.SESION' | translate" tooltipPosition="top" (click)="closeSession(rowData)"></button>
        <button *ngIf="!editing && !showOnly" pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" [pTooltip]="'GLOBAL.ELIMINAR' | translate" tooltipPosition="top" (click)="delete(rowData)" ></button>
        <button *ngIf="showAnalisisPlaza" pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-success p-ml-2 p-mr-2" [pTooltip]="'GLOBAL.VER.ESTADISTICA.PLAZA' | translate" tooltipPosition="top" (click)="goToShow(rowData.id)" ></button>
      </td>
  </tr>
</ng-template>
</p-table>

<p-messages severity="warn" *ngIf="values.length === 0" [closable]="false" styleClass="p-d-flex p-jc-center p-5">
  <ng-template pTemplate >
      <div>{{msgSinRegistros}}</div>
  </ng-template>
</p-messages>

<!-- DIALOGO PARA UN NUEVO REGISTRO  -->
<p-dialog [(visible)]="visibleNewRow" [style]="{width: '450px'}" [blockScroll]="true" [resizable]="false" [header]="headerDialogNew" [modal]="true" >
  <div class="container ">

      <form #formTable="ngForm">
        <div class="p-grid p-mb-5 p-mt-3">
      <div class="p-col-12 p-d-flex p-jc-center" *ngFor="let col of cols" [ngSwitch]="col.type">
          <label *ngIf="col.required" class=" w-25 p-mr-2" [for]="col.field">{{col.header}}*</label>
          <label *ngIf="!col.required" class=" w-25 p-mr-2" [for]="col.field">{{col.header}}</label>
          <input *ngSwitchCase="'string'" class="w-75" [hidden]="col.field === 'id'"  [required]="col.required" pInputText type="text" [name]="col.field" [placeholder]="col.header" [(ngModel)]="newRow[col.field]" />
          <p-dropdown *ngSwitchCase="'select'" placeholder="Seleccionar" class="w-75" [required]="col.required" styleClass="w-100" [name]="col.field"  [options]="col.data" optionLabel="nombre" [dataKey]="col.optionLabel" [(ngModel)]="newRow[col.field]" ></p-dropdown>
        </div>
    </div>
    </form>


    <p-footer>
    <div class="p-grid p-mt-5 p-mb-2">
    <div class="p-col-12 p-d-flex p-jc-center">
      <button pButton pRipple [label]="'GLOBAL.CANCELAR' | translate" icon="pi pi-times" class="p-button-text p-mr-3" (click)="cancelAddNew()"></button>
      <button pButton pRipple [label]="'GLOBAL.GUARDAR' | translate" icon="pi pi-check" class="p-button-text" (click)="addNew()" [disabled]="formTable.form.invalid" pTooltip="Click to proceed"></button>
    </div>
    <p>{{'GLOBAL.CAMPOS.REQUERIDOS' |translate}}</p>
  </div>
</p-footer>
  </div>
</p-dialog>
